<template>
  <svg
    id="icon_price_change"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 16"
    fill="none"
    :width="resolvedWidth"
    :height="resolvedHeight"
  >
    <title>{{ resolvedTitle }}</title>
    <path
      d="M6 13H8V12H9C9.55 12 10 11.55 10 11V8C10 7.45 9.55 7 9 7H6V6H10V4H8V3H6V4H5C4.45 4 4 4.45 4 5V8C4 8.55 4.45 9 5 9H8V10H4V12H6V13ZM18 0H2C0.89 0 0.00999999 0.89 0.00999999 2L0 14C0 15.11 0.89 16 2 16H18C19.11 16 20 15.11 20 14V2C20 0.89 19.11 0 18 0ZM18 14H2V2H18V14ZM12 6L14 4L16 6M16 10.25L14 12.25L12 10.25"
      :fill="resolvedFill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: { type: String, default: null },
    size: { type: [String, Number], default: "20px" },
    title: { type: String, default: "Price change" },
  },
  computed: {
    resolvedFill() {
      if (!this.color) return "#616161";
      const themeName = this.$store?.state?.theme;
      const themes = this.$vuetify?.theme?.themes;
      const fromTheme =
        themes?.[themeName]?.[this.color] ?? themes?.light?.[this.color];
      if (fromTheme) return fromTheme;
      return this.getColor(this.color);
    },
    resolvedTitle() {
      return this.title || "Price change";
    },
    resolvedWidth() {
      if (this.size == null || this.size === "") return "20px";
      if (typeof this.size === "number") return `${this.size}px`;
      return this.size;
    },
    resolvedHeight() {
      return this.scaleDimension(this.resolvedWidth, 16 / 20);
    },
  },
  methods: {
    scaleDimension(value, ratio) {
      if (typeof value === "number") return `${value * ratio}px`;
      const match = String(value).match(/^(-?\d*\.?\d+)([a-z%]*)$/i);
      if (!match) return value;
      const [, numericPart, unit = ""] = match;
      return `${Number(numericPart) * ratio}${unit}`;
    },
  },
};
</script>

<style>
svg {
  display: block;
  margin: 0 auto;
}
</style>
